import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  Box,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

const PlanDetailsModal = ({ isOpen, onClose, selectedPlan }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay backdropFilter="blur(8px)" />
      <ModalContent borderRadius="2xl" p={2}>
        <ModalHeader borderBottomWidth="1px">
          <VStack align="start" spacing={0}>
            <Text fontSize="lg">{selectedPlan?.name}</Text>
            <Text fontSize="xs" color="gray.500" fontWeight="normal">
              Published on {selectedPlan?.createdAt}
            </Text>
          </VStack>
        </ModalHeader>
        <ModalCloseButton mt={2} />
        <ModalBody py={6}>
          <Box
            p={4}
            bg={useColorModeValue('gray.50', 'gray.700')}
            borderRadius="xl"
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: selectedPlan?.details }}
            sx={{
              '& p': { color: useColorModeValue('gray.800', 'gray.100') },
              '& ul': { color: useColorModeValue('gray.800', 'gray.100') },
              '& ol': { color: useColorModeValue('gray.800', 'gray.100') },
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="teal"
            borderRadius="full"
            px={8}
            onClick={onClose}
          >
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PlanDetailsModal;
